export const iconFontAwesomeMarketingFish = (
	<i className="fa-solid fa-fish"></i>
);
